export enum ACTIONS {
  LOGIN = 'LOGIN',
  LOGOUT = 'LOGOUT',
  LOADING = 'LOADING',
  PERMISSIONS = 'PERMISSIONS',
}
